import { useController, useFormContext } from 'react-hook-form';
import React, { useCallback } from 'react';
import { isNumber, trim } from 'lodash';
import { useAppSelector } from '../../../store/hooks';
import { usersFilterLookupSelector } from '../../../store/selectors/coreSelectors';
import Select from '../../../core/components/select/Select';

import { BulkEditOwnerRequest } from '../types';
import { useUsersDictionary } from '../../../common/hooks/useUsersDictionary';

export const OwnerSelectField = () => {
  const usersLookup = useAppSelector(usersFilterLookupSelector);
  const { setUserSearch } = useUsersDictionary();

  const { control } = useFormContext<BulkEditOwnerRequest>();
  const { field, fieldState } = useController({ control, name: 'ownerId' });
  const { value, onChange, onBlur } = field;

  const handleSearch = useCallback((input: string) => {
    const value = trim(input).slice(0, 255);
    setUserSearch(value);
  }, [setUserSearch]);

  const handleSelect = useCallback(() => {
    setUserSearch('');
  }, [setUserSearch]);

  const handleBlur = useCallback(() => {
    setUserSearch('');
    onBlur();
  }, [setUserSearch, onBlur]);

  const handleChange = useCallback((value?: unknown) => {
    onChange(isNumber(value) ? value : null);
  }, [onChange]);

  return (
    <Select
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      value={value ?? ''}
      onChange={handleChange}
      options={usersLookup}
      showSearch
      showArrow
      onSearch={handleSearch}
      onSelect={handleSelect}
      onBlur={handleBlur}
      error={fieldState.error?.message}
      label="Owner"
      className="details-form__field--lg"
    />
  );
};
